var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTimes = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "times",
    d: "M9.091,103.5,13.9,98.693l.991-.991a.375.375,0,0,0,0-.53L13.829,96.11a.375.375,0,0,0-.53,0l-5.8,5.8-5.8-5.8a.375.375,0,0,0-.53,0L.11,97.17a.375.375,0,0,0,0,.53l5.8,5.8-5.8,5.8a.375.375,0,0,0,0,.53l1.061,1.061a.375.375,0,0,0,.53,0l5.8-5.8,4.808,4.808.991.991a.375.375,0,0,0,.53,0l1.061-1.061a.375.375,0,0,0,0-.53Z",
    transform: "translate(0 -96)",
    fill: "#535353"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTimes);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/times.12c8457837fca834f9a860fb04c79e99.svg";